// @generated by protoc-gen-es v1.2.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.assessment.llm.apis.proto (package geneo.lms.assessment.llm.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { APIResponse_CodeEnum, APIResponse_StatusEnum } from "@protos/common/common.db_pb";

/**
 * Request for evaluating an answer
 *
 * @generated from message geneo.lms.assessment.llm.apis.EvaluateAnswerRequest
 */
export class EvaluateAnswerRequest extends Message<EvaluateAnswerRequest> {
  /**
   * @generated from field: string student_id = 1;
   */
  studentId = "";

  /**
   * @generated from field: string question_id = 2;
   */
  questionId = "";

  /**
   * @generated from field: repeated string answer = 3;
   */
  answer: string[] = [];

  constructor(data?: PartialMessage<EvaluateAnswerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.llm.apis.EvaluateAnswerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EvaluateAnswerRequest {
    return new EvaluateAnswerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EvaluateAnswerRequest {
    return new EvaluateAnswerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EvaluateAnswerRequest {
    return new EvaluateAnswerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EvaluateAnswerRequest | PlainMessage<EvaluateAnswerRequest> | undefined, b: EvaluateAnswerRequest | PlainMessage<EvaluateAnswerRequest> | undefined): boolean {
    return proto3.util.equals(EvaluateAnswerRequest, a, b);
  }
}

/**
 * Response for evaluating an answer
 *
 * @generated from message geneo.lms.assessment.llm.apis.EvaluateAnswerResponse
 */
export class EvaluateAnswerResponse extends Message<EvaluateAnswerResponse> {
  /**
   * @generated from field: geneo.common.db.APIResponse.StatusEnum status = 1;
   */
  status = APIResponse_StatusEnum.STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.common.db.APIResponse.CodeEnum code = 2;
   */
  code = APIResponse_CodeEnum.UNDEFINED;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.llm.apis.EvaluationData data = 4;
   */
  data?: EvaluationData;

  constructor(data?: PartialMessage<EvaluateAnswerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.llm.apis.EvaluateAnswerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(APIResponse_StatusEnum) },
    { no: 2, name: "code", kind: "enum", T: proto3.getEnumType(APIResponse_CodeEnum) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: EvaluationData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EvaluateAnswerResponse {
    return new EvaluateAnswerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EvaluateAnswerResponse {
    return new EvaluateAnswerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EvaluateAnswerResponse {
    return new EvaluateAnswerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EvaluateAnswerResponse | PlainMessage<EvaluateAnswerResponse> | undefined, b: EvaluateAnswerResponse | PlainMessage<EvaluateAnswerResponse> | undefined): boolean {
    return proto3.util.equals(EvaluateAnswerResponse, a, b);
  }
}

/**
 * Evaluation data
 *
 * @generated from message geneo.lms.assessment.llm.apis.EvaluationData
 */
export class EvaluationData extends Message<EvaluationData> {
  /**
   * @generated from field: string student_id = 1;
   */
  studentId = "";

  /**
   * @generated from field: string question_id = 2;
   */
  questionId = "";

  /**
   * @generated from field: float marks = 3;
   */
  marks = 0;

  /**
   * @generated from field: string remarks = 4;
   */
  remarks = "";

  /**
   * @generated from field: bool has_valid_response = 5;
   */
  hasValidResponse = false;

  /**
   * @generated from field: string llm_complete_response = 6;
   */
  llmCompleteResponse = "";

  constructor(data?: PartialMessage<EvaluationData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.llm.apis.EvaluationData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "has_valid_response", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "llm_complete_response", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EvaluationData {
    return new EvaluationData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EvaluationData {
    return new EvaluationData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EvaluationData {
    return new EvaluationData().fromJsonString(jsonString, options);
  }

  static equals(a: EvaluationData | PlainMessage<EvaluationData> | undefined, b: EvaluationData | PlainMessage<EvaluationData> | undefined): boolean {
    return proto3.util.equals(EvaluationData, a, b);
  }
}

